import {
    CREATE_OR_UPDATE_TEST_CASE,
    SAVING_TEST_CASE,
    FETCHING_TEST_CASES,
    TEST_CASE_UPDATE_STATUS,
    RECEIVED_TEST_CASES,
    CLEAR_TEST_CASE_RESULTS
  } from "../actions/types.js";
  
  const initialState = {
    testCaseResults: [],
    resultsLoading: false,
    saveTestCaseLoading: false,
    createdOrUpdatedTestCase: null,
    testCaseQueryCompleted: false,
    testCaseUpdated: false,
    queryParameters: {},
    versionsLoading: false,
    testCaseVersions: []
  };
  
  export function testCaseReducer(state = initialState, action) {
    switch (action.type) {
        case CREATE_OR_UPDATE_TEST_CASE:
            return {
            ...state,
            saveTestCaseLoading: false,
            createdOrUpdatedTestCase: action.payload,
            testCaseUpdated: true,
            testCaseResults: state.testCaseResults.map(test =>
                test.id === action.payload.id ? action.payload : test
            )
            };
        case SAVING_TEST_CASE:
            return {
                ...state,
                saveTestCaseLoading: true,
                createdOrUpdatedTestCase: null,
                testCaseUpdated: false
            };
        case TEST_CASE_UPDATE_STATUS:
            return {
                ...state,
                testCaseUpdated: true
            };
        case FETCHING_TEST_CASES:
            return {
                ...state,
                resultsLoading: true,
                testCaseQueryCompleted: false,
                queryParameters: action.payload
            };
        case RECEIVED_TEST_CASES:
            return {
                ...state,
                testCaseResults: action.payload,
                resultsLoading: false,
                testCaseQueryCompleted: true
            };
        case CLEAR_TEST_CASE_RESULTS:
            return {
                ...state,
                testCaseResults: [],
                resultsLoading: false,
                testCaseQueryCompleted: false,
                queryParameters: {}
            };
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/reducers/testCaseReducer.jsx